import { Box, Checkbox, Group } from '@mantine/core';
import type { MultiSelectProps } from '@mantine/core';

/** Value used for the "All" option in filter-style multi-selects. */
export const FILTER_MULTISELECT_ALL_KEY = '__all__';

/**
 * Default renderOption for MultiSelect: checkbox to the left of each option
 * with tight spacing (gap xs). When option.value is the filter "All" key,
 * renders a distinct top section (border-bottom) for the "All" row.
 * Used in theme.ts as MultiSelect defaultProps.
 */
export const defaultMultiSelectRenderOption: NonNullable<MultiSelectProps['renderOption']> = ({
  option,
  checked,
}) => {
  const content = (
    <Group gap="xs">
      <Checkbox checked={checked} readOnly tabIndex={-1} />
      <span>{option.label}</span>
    </Group>
  );
  if (option.value === FILTER_MULTISELECT_ALL_KEY) {
    return (
      <Box pb="sm" mb="xs" style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}>
        {content}
      </Box>
    );
  }
  return content;
};
